module.exports = __webpack_public_path__ + "img/Wp_2030.98d67d91.png";